class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.desktopSearch = document.querySelector("#desktopSearch");
    this.closeDesktopSearch = document.getElementById("closeDesktopSearch");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );

    this.closeDesktopSearch.addEventListener("click", (event) => {
        event.stopPropagation();
        this.hideDesktopSearch();
    });

    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    //document.body.classList.add('overflow-hidden'); commenting due to the scroll appreaing on the right side

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    if (this.className.includes("header__search")) {
      var mainNav = document.querySelector("nav.header__inline-menu");
      mainNav.classList.add("hideSearch");
      document.querySelector('.section-header').classList.add('menu-open');
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    //document.body.classList.remove('overflow-hidden'); commenting due to the scroll appreaing on the right side
    if (this.className.includes("header__search")) {
      const mainNav = document.querySelector("nav.header__inline-menu");
      mainNav.classList.remove("hideSearch");
      document.querySelector('.section-header').classList.remove('menu-open');
    }
    if (this.desktopSearch) this.desktopSearch.style.display = "none";
    const searchInputElement = document.querySelector(
      "predictive-search input"
    );
    if (searchInputElement) searchInputElement.value = ""; // Change the input value programmatically
    if (searchInputElement)
      searchInputElement.dispatchEvent(new Event("searchreset"));
  }
  hideDesktopSearch() {
    if (this.desktopSearch) {
      this.desktopSearch.style.display = "none";
    }
  }
}

customElements.define("details-modal", DetailsModal);
